function initCtrCardsSwiper(section) {
  if (typeof Swiper === 'undefined') return;

  var carousel = section.querySelector('[data-ref="cardsSwiper"]');
  if (!carousel || carousel.swiper) return;

  new Swiper(carousel, {
    spaceBetween: 16,
    slidesPerView: 1.3,
    grabCursor: true,
    loop: false,
    navigation: {
      nextEl: carousel.querySelector('.swiper-button-next'),
      prevEl: carousel.querySelector('.swiper-button-prev'),
    },
    breakpoints: {
      768: {
        spaceBetween: 12,
        slidesPerView: 3,
      },
      1200: {
        grabCursor: false,
        spaceBetween: 18,
        slidesPerView: 4.5,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ctr-cards[data-section-id]').forEach(initCtrCardsSwiper);
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.ctr-cards[data-section-id]');
    if (section) initCtrCardsSwiper(section);
  });
}
